import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        userId: window.sessionStorage.getItem('userId'),
        userName: window.sessionStorage.getItem('userName'),
        token: window.sessionStorage.getItem('token'),
    },
    mutations: {
        GET_USERID: (state, data) => {
            // 把用户名存起来
            state.userId = data.userId;
            state.userName = data.userName;
            state.token = data.token;
            window.sessionStorage.setItem('userId', data.userId);
            window.sessionStorage.setItem('userName', data.userName)
            window.sessionStorage.setItem('token', data.token)
        },
        LOGOUT: (state) => {
            // 登出的时候要清除用户名
            state.userId = null
            state.userName = null
            state.token = null
            window.sessionStorage.removeItem('userId');
            window.sessionStorage.removeItem('userName');
            window.sessionStorage.removeItem('token');
        }
    },
    actions: {},
    modules: {}
})
export default store
